import React from 'react';

function Button(props) {
  let classes =
    'mb-15 md:mb-0 py-15 px-30 w-full md:w-auto inline-block leading-12 text-12 font-normal font-mont-700 font-w-700 rounded uppercase tracking-1 text-center transition-all transition-500 ' +
    props.classes;

  if (props.buttonType === 'primary') {
    classes +=
      ' bg-primary border-primary border-solid border-1 hover:bg-almost-black hover:border-almost-black focus:bg-almost-black focus:border-almost-black text-white';
  } else if (props.buttonType === 'secondary') {
    classes +=
      ' bg-white border-primary border-solid border-1 text-primary hover:border-almost-black hover:text-almost-black focus:border-almost-black focus:text-almost-black';
  } else if (props.buttonType === 'tertiary') {
    classes += ' bg-white border-white border-solid border-1 hover:text-almost-black focus:text-almost-black text-primary';
  }

  return (
    <button className={classes} type={props.type} name={props.name} onClick={props.onclick} disabled={props.disabled}>
      {props.value}
    </button>
  );
}

export default Button;
